import React from "react";
import "./Footer.css";

const Footer = ({ userData }) => {
  return (
    <>
      {false && (
        <section
          className="text-center py-4 px-4 landing-footer-section"
          style={{ backgroundColor: "#eff1f1" }}
        >
          <footer className="bg-footer text-dark pt-1">
            <div className="container-fluid">
              <div className="row d-flex justify-content-center align-items-center">
                <div className="col-12 footer-container-flex">
                  <nav className="footer-nav text-center justify-content-center">
                    <a
                      href="/about-us"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      About Us
                    </a>
                    <span className="footer-separator">|</span>

                    {/* <a
                  href="/Pricing"
                  target="_blank"
                  className="text-dark mx-2 text-16 md:text-18"
                  rel="noopener noreferrer"
                >
                  Pricing Plan
                </a>
                <span className="footer-separator">|</span> */}

                    <a
                      href="/refund-cancellation"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      Refund & Cancellation
                    </a>
                    <span className="footer-separator">|</span>

                    <a
                      href="/disclaimer"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      Disclaimer
                    </a>
                    <span className="footer-separator">|</span>

                    <a
                      href="/privacy-policy"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      Privacy Policy
                    </a>
                    <span className="footer-separator">|</span>

                    <a
                      href="/terms-conditions"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      Terms & Conditions
                    </a>
                    <span className="footer-separator">|</span>

                    <a
                      href="/ipr-copyright"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      IPR & Copyright
                    </a>
                    <span className="footer-separator">|</span>

                    <a
                      href="/contact-us"
                      className="text-dark mx-2 text-16 md:text-18"
                    >
                      Contact Us
                    </a>

                    {userData?.admin_id && (
                      <>
                        <span className="footer-separator">|</span>
                        <a
                          href="/view-tickets"
                          className="text-dark mx-2 text-16 md:text-18"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Raise Your Concern
                        </a>
                      </>
                    )}
                  </nav>

                  <div className="social-icons-container">
                    {/* Social icons commented out - uncomment when images are available */}
                  </div>
                </div>
              </div>
            </div>
          </footer>
        </section>
      )}
    </>
  );
};

export default Footer;
